import { CalendarViewType } from '../schema';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { createWorkWeekDaysArray } from 'owa-datetime-utils';
import { getWorkDays } from './dateUtils';

export const NUM_DAYS_WEEK_VIEW = 7;

export function getCalendarViewTypeOptions(): CalendarViewType[] {
    return Object.values(CalendarViewType).map(viewType => viewType as CalendarViewType);
}

export function getFluentDateRangeType(calendarViewType: CalendarViewType): DateRangeType {
    switch (calendarViewType) {
        case CalendarViewType.Day:
            return DateRangeType.Day;
        case CalendarViewType.Week:
            return DateRangeType.Week;
        case CalendarViewType.WorkWeek:
            return DateRangeType.WorkWeek;
        case CalendarViewType.Month:
            return DateRangeType.Month;
        default:
            return DateRangeType.Day;
    }
}

export function getNumDaysWeekViews(calendarViewType: CalendarViewType): number {
    const workDays = getWorkDays();
    const workWeekDays = createWorkWeekDaysArray(workDays);
    return calendarViewType == CalendarViewType.WorkWeek ? workWeekDays.length : NUM_DAYS_WEEK_VIEW;
}

export function isDayGridViewType(calendarViewType: CalendarViewType): boolean {
    return (
        calendarViewType === 'day' || calendarViewType === 'week' || calendarViewType === 'workweek'
    );
}
